import { render, staticRenderFns } from "./schedule_home.vue?vue&type=template&id=235a11c8&scoped=true"
import script from "./schedule_home.vue?vue&type=script&lang=js"
export * from "./schedule_home.vue?vue&type=script&lang=js"
import style0 from "./schedule_home.vue?vue&type=style&index=0&id=235a11c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a11c8",
  null
  
)

export default component.exports